import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';

import MultiSelect from 'web/components/form-elements/MultiSelect';
import TextInput from 'web/components/form-elements/TextInput';

import { Form, Formik, Field } from 'formik';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import {
    groupUpdate,
    sellerUpdate,
} from 'redux/actions/addGroup';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './group.scss';

export default ({ isOpen, toggle, title, editGroupState, link, dropDownList, editHandler }) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('/');
    const toggleModal = () => setModal(!modal);

    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );
    const redirectLink = (link) => {
        history.push(link);
    }
    const dropDownArr = [
        {
            label: '',
            value: '',
        },
    ];
    let INITIAL_VALUES = {
        groupName: editGroupState.name,
        edit: ''
    }

    const userType = localStorage.getItem('userType');
    const token = localStorage.getItem('token');
    const handleUpdateGroup = async (props) => {
        let sellerIdArr = [];
        let response = '';
        if (userType === 'Buyer') {
            for (let i = 0; i < props.values.edit.length; i++) {
                let obj = {
                    sellerId: props.values.edit[i].value,
                };
                sellerIdArr.push(obj);
            }

            let data = {
                id: editGroupState.id,
                groupName: props.values.groupName,
                seller: sellerIdArr,
            };
            response = await dispatch(groupUpdate(data, token));
        } else {
            for (let i = 0; i < props.values.edit.length; i++) {
                let obj = {
                    buyerId: props.values.edit[i].value,
                };
                sellerIdArr.push(obj);
            }

            let data = {
                id: editGroupState.id,
                groupName: props.values.groupName,
                buyer: sellerIdArr,
            };
            response = await dispatch(sellerUpdate(data, token));
        }

        if (response.status === 'SUCCESS') {
            editHandler();
            toggle();
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
        } else {
            if (response.message === "Unauthorized (Invalid token)") {
                history.push('/sign-in')
                window.location.reload(false);
              }else{
            setModalContent(response.message);
            setModalLink('');
            toggleModal();
              }
        }
    }
    return (
        <div className='alert-modal'>
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                backdrop={'static'}
                centered={true}
                className='my-group-modal'>
                <div className='modal-content'>
                    <div className='header'>
                        <Button handleClick={() => {
                            toggle(!isOpen)
                        }}>
                            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
                        </Button>
                        <h3></h3>
                    </div>

                    <ModalBody>
                        <div className='groupsContainer'>
                            {loaderVisible && <Spinner />}
                            <div className='heading'>
                                <div></div>
                                <h3>{title}</h3>
                                <div></div>
                            </div>
                            <Formik
                                initialValues={INITIAL_VALUES}
                                onSubmit={(values) => { }}>
                                {(props) => {
                                    const { isValid, dirty, values, errors, touched, setFieldValue } = props;
                                    return (
                                        <>
                                            <Form>
                                                <div className='section'>
                                                    <div className='row mx-0'>
                                                        <div className='col-12'>
                                                            <div className='my-2'>
                                                                <p>Group Name *</p>
                                                            </div>
                                                            <div>
                                                                <TextInput
                                                                    name='groupName'
                                                                    inputType="text"
                                                                    placeholder='Group Name*'
                                                                    showErrorMessages={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row mx-0'>
                                                        <div className='col-12'>
                                                            <div className='my-2'>
                                                                {userType === 'Buyer' ? (<p>Add Sellers *</p>) : (<p>Add Buyers *</p>)}
                                                            </div>
                                                            <div>
                                                                <MultiSelect
                                                                    name='edit'
                                                                    defaultValueArr={editGroupState.groups}
                                                                    data={dropDownList}
                                                                    placeholder='Add Sellers&#42;'
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='row mx-0'>
                                                        <div className='col-12'>
                                                            <div className='btnSection' >
                                                                <Button
                                                                    type='app-green-button'
                                                                    name="createGroup"
                                                                    handleClick={() => {
                                                                        handleUpdateGroup(props);
                                                                    }}
                                                                    disabled={!(isValid && dirty)}>
                                                                    Update
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Form>
                                        </>
                                    );
                                }}
                            </Formik>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                content={modalContent}
                link={modalLink}
            />
        </div>
    );
};